import Vue from 'vue'
const QrCode = () => import(/* webpackPrefetch: true */'./QrCode.vue')

Vue.component('QrCode', QrCode)